import { useAtomValue } from "jotai";
import { EProfileTab } from "library/types";
import { selectedProfileTabAtom } from "store/UIProfilePage";
import styled from "styled-components";

import { AppLogoSpinner } from "components/AppLogoSpinner/AppLogoSpinner";
import { CollapseWrapper } from "components/effects/CollapseWrapper";
import useEmployee from "hooks/useEmployee";

import { EmployeeConsents } from "./components/EmployeeConsents/EmployeeConsents";
import { EmployeeDependents } from "./components/EmployeeDependents/EmployeeDependents";
import { EmployeeDocuments } from "./components/EmployeeDocuments/EmployeeDocuments";
import { EmployeeForm } from "./components/EmployeeForm/EmployeeForm";
import { ProfileHeader } from "./components/ProfileHeader/ProfileHeader";
import { ProfilePageContentSelect } from "./components/ProfilePageContentSelect";

export function ProfilePage() {
  const { employeeData } = useEmployee();

  const selectedTab = useAtomValue(selectedProfileTabAtom);

  if (!employeeData) {
    return <AppLogoSpinner />;
  }
  return (
    <Container>
      <ProfilePageContentSelect />
      <CollapseWrapper visible={selectedTab === EProfileTab.info}>
        <div>
          <ProfileHeader />
          <EmployeeForm />
        </div>
      </CollapseWrapper>
      <CollapseWrapper visible={selectedTab === EProfileTab.consents}>
        <EmployeeConsents />
      </CollapseWrapper>
      <CollapseWrapper visible={selectedTab === EProfileTab.documents}>
        <EmployeeDocuments />
      </CollapseWrapper>
      <CollapseWrapper visible={selectedTab === EProfileTab.dependents}>
        <DependentsWrap>
          <EmployeeDependents />
        </DependentsWrap>
      </CollapseWrapper>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const DependentsWrap = styled.div`
  margin-top: 20px;
`;
